import API from "../services/api"; // Adjust the path to where your api.js file lives

// Function to convert your VAPID key to a format the browser expects
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export const initAdminPushNotifications = async () => {
  // 1. Verify browser supports push notifications
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.warn("Push notifications are not supported by this browser.");
    return;
  }

  try {
    // 2. Register the background service worker
    const registration = await navigator.serviceWorker.register('/sw.js');
    
    // 3. Request permissions from the admin
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.warn("Admin blocked or dismissed notification permissions.");
      return;
    }

    // 4. Generate the subscription payload using your VAPID Public Key
    // Paste the PUBLIC key string generated from npx web-push generate-vapid-keys here
    const PUBLIC_VAPID_KEY = "BI7ISXKczrFGSQsZPQ-4kpireju_rXTzGdEwkInqaX3mmE_4y3xBlM-JpfhRpNjVfLplu1OIdjYdwc0BpeuBbgw"; 
    
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(PUBLIC_VAPID_KEY)
    });

    // 5. Fire it off using your custom configured axios instance
    // This hits: https://backend.gadimart.in/api/v1/admin/notifications/save-token
    await API.post('/notifications/save-token', {
      token: subscription // Sends the {endpoint, keys} browser object
    });

    console.log("Admin Web Push registered successfully via GadiMart API!");
  } catch (error) {
    console.error("Error setting up web push notifications:", error);
  }
};